<template>
	<div>
		<van-nav-bar title="投诉" left-text="返回" left-arrow fixed placeholder @click-left="onClickLeft" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />

		<van-form @submit="onSubmit">
			<van-cell-group title="投诉内容">
				<van-field v-model="this.$Setting.web_title" label="投诉账号" placeholder="投诉账号" readonly error />
				<van-field v-model="title" name="title" label="投诉描述" placeholder="投诉描述" :rules="[{ required: true, message: '请填写投诉描述' }]" />
				<van-field v-model="content" name="content" rows="5" autosize label="投诉内容" type="textarea" placeholder="请输入投诉内容"
				 maxlength="100" show-word-limit :rules="[{ required: true, message: '请填写投诉内容' }]" />
			</van-cell-group>
			<van-cell-group title="请填写你的个人信息,方便我们联系您">
				<van-field v-model="phone" name="phone" label="手机号" placeholder="选填" />
				<van-field v-model="wechat" name="wechat" label="微信号" placeholder="选填" />
			</van-cell-group>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">
					提交
				</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		NavBar,
		CellGroup
	} from 'vant';

	Vue.use(CellGroup);
	Vue.use(NavBar);
	export default {
		data() {
			return {
				title: '',
				content: '',
				phone: '',
				wechat: ''
			}
		},
		created() {},
		methods: {
			onClickLeft() {
				this.$router.go(-1)
			},
			onSubmit(e) {
				this.$ApiUtil.Feedbook.post({
					put: JSON.stringify(e)
				}).then((res) => {
					this.$dialog.alert({
						message: res.message
					}).then(() => {
						this.$router.go(0)
					})
				})
			}
		}
	}
</script>

<style>
</style>
